customElements.get("sticky-atc-bar") || customElements.define("sticky-atc-bar", class extends HTMLElement {
  constructor() {
    super();
    document.body.classList.add("sticky-atc-bar-enabled");
  }

  get variantIdSelect() {
    return this.querySelector('[name="id"]');
  }

  connectedCallback() {
    this.productFormActions = document.querySelector(".main-product-form");
    this.mainProductInfo = document.querySelector("product-info");
    this.container = this.closest(".sticky-atc-bar");
    this.variantData = this.getVariantData();
    this.select = this.querySelector("select");
    this.init();

    // FIX: null-check toegevoegd — bij enkelvoudige variant is er geen <select>
    if (this.select) {
      this.select.addEventListener("change", () => {
        if (this.isUpdating) return;
        this.isUpdating = true;
        this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector("variant-selects");
        const selectedId = this.variantIdSelect.value;
        this.currentVariant = this.variantData.find(v => v.id === Number(selectedId));

        if (this.mainVariantSelects) {
          Array.from(this.mainVariantSelects.querySelectorAll("select, fieldset"), (el, index) => {
            const optionValue = this.currentVariant.options[index];
            switch (el.tagName) {
              case "SELECT":
                el.value = optionValue;
                el.querySelectorAll("option").forEach(opt => opt.removeAttribute("selected"));
                el.value = optionValue;
                const matchedOption = el.querySelector(`option[value="${optionValue}"]`);
                if (matchedOption) matchedOption.setAttribute("selected", "selected");
                break;
              case "FIELDSET":
                Array.from(el.querySelectorAll("input")).forEach(input => {
                  if (input.value === optionValue) input.checked = true;
                });
                break;
            }
          });

          setTimeout(() => {
            this.mainVariantSelects.dispatchEvent(new Event("change", { detail: { formStickty: true } }));
            this.isUpdating = false;
          }, 0);
        } else {
          this.isUpdating = false;
        }

        this.updatePrice();
        this.updateButton(true, "", false);
        this.currentVariant
          ? this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut)
          : this.updateButton(true, "", true);
      });
    }
  }

  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
  }

  init() {
    if (!this.productFormActions) return void this.container.classList.add("sticky-atc-bar--show");

    this.productId = this.dataset.productId;
    window.matchMedia(FoxTheme.config.mediaQueryMobile).onchange = this.checkDevice.bind(this);
    this.checkDevice();

    const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.container.classList.toggle("sticky-atc-bar--show", !entry.isIntersecting);
      });
    }, { threshold: 1, rootMargin });

    this.observer.observe(this.productFormActions);
    this.syncWithMainProductForm();
  }

  checkDevice() {
    document.documentElement.style.setProperty("--sticky-atc-bar-height", this.clientHeight + "px");
  }

  updateButton(disable = true, text, restoreText = true) {
    const form = this.querySelector(".sticky-atc-bar__form");
    if (!form) return;
    const btn = form.querySelector('[name="add"]');
    if (!btn) return;
    const span = btn.querySelector("span");
    if (disable) {
      btn.setAttribute("disabled", "disabled");
      if (text && span) span.textContent = text;
    } else {
      btn.removeAttribute("disabled");
      if (span) span.textContent = FoxTheme.variantStrings.addToCart;
    }
  }

  updatePrice() {
    const saleClass = "f-price--on-sale";
    const soldOutClass = "f-price--sold-out";
    const moneyFormat = FoxTheme.settings.moneyFormat;

    const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes({
      priceWrapper: ".f-price",
      salePrice: ".f-price-item--sale",
      compareAtPrice: [".f-price-item--regular"],
      unitPriceWrapper: ".f-price__unit-wrapper"
    }, this);

    const unitPriceEl = unitPriceWrapper.querySelector(".f-price__unit");
    const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

    if (compare_at_price && compare_at_price > price) {
      priceWrapper.classList.add(saleClass);
    } else {
      priceWrapper.classList.remove(saleClass);
    }

    if (this.currentVariant.available) {
      priceWrapper.classList.remove(soldOutClass);
    } else {
      priceWrapper.classList.add(soldOutClass);
    }

    if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

    if (compareAtPrice && compareAtPrice.length) {
      if (compare_at_price > price) {
        compareAtPrice.forEach(el => el.innerHTML = `<s>${FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat)}</s>`);
      } else {
        compareAtPrice.forEach(el => el.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat));
      }
    }

    if (unit_price_measurement && unitPriceEl) {
      unitPriceWrapper.classList.remove("hidden");
      unitPriceEl.innerHTML = `<span>${FoxTheme.Currency.formatMoney(this.currentVariant.unit_price, moneyFormat)}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
    } else {
      unitPriceWrapper.classList.add("hidden");
    }
  }

  syncWithMainProductForm() {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, event => {
      if (!(event.data.sectionId === this.mainProductInfo.dataset.section)) return;
      const variant = event.data.variant;
      const selectEl = this.querySelector('[name="id"]');
      this.currentVariant = variant;
      if (selectEl) selectEl.value = variant.id;
      this.updatePrice();
      this.updateButton(true, "", false);
      variant
        ? this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut)
        : this.updateButton(true, "", true);
    });
  }
});